import styled from "styled-components"
import { Flex } from "../Flex/Flex.styled"
import React from "react-dom"
import { Fragment,useContext  } from "react"
import { NavButton } from "../Button/Button.styled"
import { AppContext } from "../../App"
import { StyledNavbar } from "../Navbar/Navbar.styled"
//Add react router 

const StyledMenu = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.primary};
  position: fixed;
  top: 0;
  left: 0;
  height: 40vh;
  width: 100vw;
  z-index: 10000;
  transition: 0.4s ease;
  color: black;
  & div {
    color:white;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:space-around;
    font-size:17px;
    margin-left:1em;
    height:80%;
  }
  a {
    color:white;
  }
`;


const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgb(0,0,0,0.001);
  z-index: 1000;
`;
function Menu () {
      const toggleMenu = useContext(AppContext)
    return (
      <StyledMenu>
        <StyledNavbar bColor={"#725cff"}>
          <p style= {{color:"#fff"}}>Akintobi Ibukunoluwa </p>
          <NavButton onClick={toggleMenu}>Close</NavButton>
        </StyledNavbar>
        <div>
          <a href = "/" > Home </a>
          <a href = "#about"> About</a> 
          <a href = "#projects">Projects </a>
          <a href = "#contact"> Contact </a>
        </div>
      </StyledMenu>
    );
}



const Dropdown = () => {
  return (
      <Fragment>
        { React.createPortal(<Backdrop/>,document.getElementById("menu"))}
        { React.createPortal(<Menu/>,document.getElementById("menu"))}
      </Fragment>
       
     )
}


export default Dropdown


